// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle2":"SectionTitleTwo_sectionTitle2__1AdI_"};